/**
 * MSAL account names arrive formatted as "Last Name, First Name". This splits
 * that into first/last parts, falling back to "First Last" order when there's
 * no comma (e.g. in local/dev environments).
 */
export function parseAccountName(
    fullName?: string | null,
): { first: string; last: string } | undefined {
    if (!fullName) return undefined;

    if (fullName.includes(",")) {
        const [last, first] = fullName.split(",").map((part) => part.trim());
        return {
            first: first?.split(" ")[0] ?? "",
            last: last?.split(" ").pop() ?? "",
        };
    }

    const parts = fullName.trim().split(" ").filter(Boolean);
    return { first: parts[0] ?? "", last: parts[parts.length - 1] ?? "" };
}
